<script>
  import { onMount } from "svelte";
  import {
    modalStore,
    dataEdit,
    viewsData,
    addDoc,
    updateD,
    panelController,
    getInt,
    modalS,
    updateService,
    controllers,
  } from "../../stores/service";

  import {
    loadDocuments,
    countDocs,
    afterDocuments,
    readDocuments /*  */,
  } from "../../Controller/Menbresia";

  import {
    delDoc,
    createNewDate as newDate,
    printdate,
  } from "../../stores/CES";

  let doc1;
  let doc2;
  let value = [];

  let createNewDate = newDate();



  onMount(async () => {
    $panelController.viewMembresias.status = false;
    let data = await countDocs("service");

    if (data.data > 0) {
      $panelController.viewMembresias.pag={
        total:data.data,
        actual:0,
        paginacion:0
      }
      await mainView();
    } else {
      $modalS.reset();
      $modalS.info.title = "Aviso";
      $modalS.info.body = `No hay datos `;
      $modalS.controllers.btn[0].text = `Aceptar`;
      $modalS.controllers.btn[0].status = false;
      $modalS.controllers.btn[1].status = true;
      $modalS.controllers.input.status = false;
      $modalS.controllers.btnClose = false;

      let modal = await $modalS.mostrar();
      if (modal) {
        newMembr(index, data);
      }
    }
  });

  function addMonthsToDate(date, months) {
    // Crear una nueva instancia de Date a partir de la fecha proporcionada
    let resultDate = new Date(date);

    // Obtener el día del mes original
    let day = resultDate.getDate();

    // Añadir los meses a la fecha
    resultDate.setMonth(resultDate.getMonth() + months);

    // Ajustar el día del mes en caso de que el mes destino no tenga el mismo número de días
    if (resultDate.getDate() < day) {
      resultDate.setDate(0); // Ir al último día del mes anterior
    }
    return resultDate;
  }

  export const vencimiento = (fechaPartida, m) => {
    let numeroMeses = parseInt(m, 10);
    // Obtener el día del mes original
    let day = fechaPartida.getDate();

    // Añadir los meses a la fecha
    fechaPartida.setMonth(fechaPartida.getMonth() + numeroMeses);

    // Ajustar el día del mes en caso de que el mes destino no tenga el mismo número de días
    if (fechaPartida.getDate() < day) {
      fechaPartida.setDate(0); // Ir al último día del mes anterior
    }

    return `${String(fechaPartida.getDate()).padStart(2, "0")}-${String(fechaPartida.getMonth() + 1).padStart(2, "0")}-${fechaPartida.getFullYear()}`;
  };

  async function mainView() {
    let value = await readDocuments();
    sistem(value);
  }

  function sistem(data){
    if (data.status && data.data.length > 0) {
      $panelController.viewMembresias.result = data.data;
      $panelController.viewMembresias.querySnapshot = data.querySnapshot;
      $panelController.viewMembresias.status = true;
      
      /* $panelController.viewMembresias.pag.actual = $panelController.viewMembresias.pag.actual + data.data.length; */
      /* $panelController.viewMembresias.btn[0].status = true;
      $panelController.viewMembresias.btn[1].status = true; */
    }
    

    if($panelController.viewMembresias.pag.actual > 1){

      $panelController.viewMembresias.btn[0].status = true;

    }else{

      $panelController.viewMembresias.btn[0].status = false;

    }

    if($panelController.viewMembresias.pag.actual < $panelController.viewMembresias.pag.total){
      $panelController.viewMembresias.btn[1].status = true;
    }else{
      $panelController.viewMembresias.btn[1].status = false;
    }
  }


  async function newMembr(index, data) {
    if ($modalS.controllers.input.value <= 0) {
      $panelController.viewMembresias.result[index].doc.service.sub = false;
      $modalS.controllers.input.label = "Numero no valido";
      nuevaMemb(index, data);
    } else {
      $panelController.viewMembresias.result[index].doc.service.sub = true;
      $panelController.viewMembresias.result[index].doc.service.date =
        new Date();
      $panelController.viewMembresias.result[index].doc.service.duracion =
        $modalS.controllers.input.value;
    }
  }


  async function ant() {
    $panelController.viewMembresias.status = false;
    let next = await afterDocuments();
    sistem(next.data);
  }


  async function sig() {
    $panelController.viewMembresias.status = false;
    let after = await loadDocuments(
      $panelController.viewMembresias.querySnapshot[1]
    );
    sistem(after);
  }


  async function nuevaMemb(index, data) {
    $panelController.viewMembresias.result[index].doc.service.sub = false;

    /* Cambiar */
    $modalS.reset();
    $modalS.info.title = "Aviso";
    $modalS.info.body = `Se va activar la suscripción de ${data.tableadmins[0].name}`;
    $modalS.controllers.input.placeholder = "Numero de meses.";
    $modalS.controllers.btn[0].text = `Activar`;
    $modalS.controllers.btn[1].text = `No, cancelar`;
    $modalS.controllers.btn[0].status = true;
    $modalS.controllers.btn[1].status = true;
    $modalS.controllers.input.status = true;
    $modalS.controllers.btnClose = false;

    let modal = await $modalS.mostrar();
    if (modal) {
      newMembr(index, data);
    } else {
      $panelController.viewMembresias.result[index].doc.service.sub = false;
    }
  }


  async function controlbtn(opc) {
    switch (opc) {
      case 0:

      $panelController.viewMembresias.status = false;
    let after = await afterDocuments($panelController.viewMembresias.querySnapshot[1]);
    if (after.status) {
      $panelController.viewMembresias.pag.paginacion--;
      sistem(after);
    }
    
      
        break;


      case 1:

    $panelController.viewMembresias.status = false;

    let next = await loadDocuments(
      $panelController.viewMembresias.querySnapshot[1]
    );

    if (next.status) {
      $panelController.viewMembresias.pag.paginacion++;
    }

    sistem(next);

        break;

      default:
        break;
    }
  }


</script>

{#if $panelController.viewMembresias.status}
  <div class="card text-center">
    <div class="card-header">Clientes</div>
    <div class="card-body">
      <div class="row center">
        <div class="form-group col-1">
          <label for="numero1">N.</label>
        </div>
        <div class="form-group col-2">
          <label for="numero1">Cuenta</label>
        </div>

        <div class="form-group col-1">
          <label for="numero3">Estatus</label>
        </div>

        <div class="form-group col-2">
          <label for="numero3">Fecha de creación</label>
        </div>

        <div class="form-group col-2">
          <label for="numero4">Fecha de suscripción</label>
        </div>

        <div class="form-group col-2">
          <label for="numero4">Meses</label>
        </div>

        <div class="form-group col-2">
          <label for="numero5">Finaliza</label>
        </div>
      </div>
      {#each $panelController.viewMembresias.result as item, index}
        <div class="row center">
          <div class="form-group col-1">
            <p>{index + 1}</p>
          </div>
          <div class="form-group col-2">
            <p>
              {item.doc.tableadmins[0].name} - {item.doc.tableadmins[0].email}
            </p>
          </div>
          <div class="form-check form-switch col-1">
            <p>Activar</p>
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              bind:checked={$panelController.viewMembresias.result[index].doc
                .service.sub}
              on:change={() => nuevaMemb(index, item.doc)}
            />
          </div>

          <div class="form-group col-2">
            <label for="numero3">{item.doc.date}</label>
          </div>

          {#if item.doc.service.sub && item.doc.service.duracion > 0}
            <!-- <div class="form-group col-4">
              <p>{item.doc.service.membresia.date}</p>
            </div>
            <div class="form-group col-4">
              <p>
                {item.doc.service.membresia.time} - {() => {
                  vencimiento(
                    item.doc.service.membresia.date,
                    item.doc.service.membresia.time
                  );
                }}
              </p>
            </div> -->

            <div class="form-group col-2">
              <label for="numero4">{printdate(item.doc.service.date)}</label>
            </div>

            <div class="form-group col-2">
              <label for="numero5">
                {item.doc.service.duracion}
              </label>
            </div>

            <div class="form-group col-2">
              <label for="numero5">
                {vencimiento(item.doc.service.date, item.doc.service.duracion)}
              </label>
            </div>
          {:else}
            <div class="form-group col-2">
              <label for="numero3">No activo</label>
            </div>

            <div class="form-group col-2">
              <label for="numero3">No activo</label>
            </div>

            <div class="form-group col-2">
              <label for="numero3">No activo</label>
            </div>
          {/if}
        </div>
      {/each}
    </div>
    <div class="card-footer text-body-secondary m-1">
      {#each $panelController.viewMembresias.btn as btn, index}
        {#if btn.status}
          <button
            type="button"
            class="btn btn-light m-1"
            on:click={() => {
              controlbtn(index);
            }}>{btn.text}</button
          >
        {/if}
      {/each}
    </div>
  </div>
{:else}
  <button class="btn btn btn-light m-1" disabled>
    <span class="spinner-grow spinner-grow-sm"></span>
    Loading..
  </button>
{/if}

<style>
  .form-control {
    text-align: center;
  }
  .valid-c {
    color: green;
  }
  .valid-i {
    color: red;
  }
</style>
